import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import swichh from './images/switchh.png';

function Modify() {
  const navigate = useNavigate();
  const location = useLocation();
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [message, setMessage] = useState('');
  const [usingBackCamera, setUsingBackCamera] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const { imageName } = location.state || {}; // Get imageName from the location state

  useEffect(() => {
    const email = sessionStorage.getItem('userEmail');
    setUserEmail(email);

    if (!email || !imageName) {
      navigate('/signin');
      return;
    }

    const constraints = {
      video: {
        width: { ideal: 640 },
        height: { ideal: 480 },
        facingMode: usingBackCamera ? { exact: 'environment' } : 'user',
      },
    };

    const getMedia = async () => {
      // Stop existing tracks if any
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }

      try {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        videoRef.current.srcObject = stream;
      } catch (err) {
        console.error('Error accessing the camera: ', err);
        setMessage('Error accessing the camera');
      }
    };

    getMedia();

    // Cleanup function to stop the stream on component unmount
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, [usingBackCamera, navigate, imageName]);

  const captureImage = () => {
    if (canvasRef.current && videoRef.current) {
      const context = canvasRef.current.getContext('2d');
      context.drawImage(videoRef.current, 0, 0, 640, 480);
      const imageData = canvasRef.current.toDataURL('image/png'); // Capturing the image in Base64 format
      return imageData;
    }
    return null;
  };

  const handleConfirm = async () => {
    const capturedImage = captureImage();

    if (!capturedImage) {
      setMessage('Failed to capture image');
      return;
    }

    try {
      // Sending the captured image and imageName to the backend for replacement
      const response = await fetch('/api/replace-imagee', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userEmail,
          image: capturedImage, // Sending the captured image as Base64 string
          imageName, // Sending the old image name to be replaced
        }),
      });

      const result = await response.json();
      if (response.ok) {
        setMessage('Image replaced successfully');
        setTimeout(() => {
          navigate('/ViewsEdits'); // Navigate to ViewEdit after successful image replacement
        }, 2000); // Wait 2 seconds before redirecting
      } else {
        setMessage(result.error || 'Failed to replace image');
      }
    } catch (error) {
      console.error('Error replacing image:', error);
      setMessage('Error replacing image');
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleSwitchCamera = () => {
    // Toggle the camera
    setUsingBackCamera((prevState) => !prevState);
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center', background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)', minHeight: '100vh' }}>
      <h2 style={{ color: '#E11584' }}>Edit Page</h2>

      <p style={{ color: '#E11584', fontSize: '20px' }}>
        Signed in as: {userEmail}
      </p>

      {/* Displaying imageName */}
      {imageName && (
        <p style={{ color: '#E11584', fontSize: '18px' }}>
          Current Image: {imageName}
        </p>
      )}

      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
        <video
          ref={videoRef}
          width="100%"
          height="auto"
          autoPlay
          style={{ borderRadius: '8px', backgroundColor: 'black' }} // Ensure full-width for mobile view
        />
      </div>

      <canvas ref={canvasRef} width="640" height="480" style={{ display: 'none' }}></canvas>

      <button
        onClick={handleConfirm}
        style={{ backgroundColor: '#E11584', color: 'black', padding: '10px 20px', fontSize: '14px', border: 'none', borderRadius: '8px', cursor: 'pointer', margin: '10px', width: '100%' }} // Full-width for mobile
      >
        Confirm
      </button>

      <button
        onClick={handleBack}
        style={{ backgroundColor: '#E11584', color: 'black', padding: '10px 20px', fontSize: '14px', border: 'none', borderRadius: '8px', cursor: 'pointer', margin: '10px', width: '100%' }} // Full-width for mobile
      >
        Back
      </button>

      {/* Switch Camera Button */}
      <button
        type="button"
        onClick={handleSwitchCamera}
        style={{
          backgroundColor: '#E11584',
          border: 'none',
          cursor: 'pointer',
          padding: '10px',
          borderRadius: '5px',
          margin: '10px',
          width: '100%', // Full-width for mobile
        }}
      >
        <img src={swichh} width="30" height="30" alt="Switch Camera" />
      </button>

      {/* Message Displayed Below */}
      {message && <p style={{ color: message.includes('successfully') ? 'green' : 'red', marginTop: '20px' }}>{message}</p>}
    </div>
  );
}

export default Modify;
